import React from "react"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import VerifyLogin from "pages/Authentication/VerifyLogin";
// import ResetPassword from "../pages/Authentication/"

import { adminRoutes } from "./admin"
import { customerRoutes } from "./customer"
import ResetPassword from "pages/ResetPassword/resetPassword"

const getAllSubmenuItems = (menus) => {
  const allSubmenuItems = [];

  const traverse = (menuItems) => {
    menuItems.forEach(menu => {
      if (menu.submenu) {
        menu.submenu.forEach(submenu => {
          allSubmenuItems.push(submenu);
          if (submenu.submenu) {
            traverse([submenu]);
          }
        });
      }
    });
  };

  traverse(menus);
  return allSubmenuItems;
};

const adminSubMenuRoutes = (roleName) => {
  const menus = adminRoutes(roleName).filter(r => r.hasOwnProperty("submenu"));
  return getAllSubmenuItems(menus);
};

const publicRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/verify-login/:uuid", component: <VerifyLogin /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/register", component: <Register /> },
]

const authProtectedRoutes = (roleName)=> {
  return [
  ...adminRoutes(roleName),
  ...adminSubMenuRoutes(roleName),
]
}



const dealerRoutes = [...customerRoutes]

export { authProtectedRoutes, publicRoutes, dealerRoutes }
